export const MobileHomeSegments = () => (
  <div className="bg-tertiary border-primary flex flex-col gap-10 gap-y-2 rounded-lg border p-6">
    <div className="border-primary bg-primary h-14" />
    <div className="border-primary bg-primary h-14" />
    <div className="border-primary bg-primary h-14" />
    <div className="border-primary bg-primary h-14" />
  </div>
);
